/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Plan_Tab_Price_Per_UserInputs */



/**
* | output |
* | --- |
* | "€{price} / user / month" |
*
* @param {Plan_Tab_Price_Per_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_price_per_user = /** @type {((inputs: Plan_Tab_Price_Per_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Price_Per_UserInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`€${i?.price} / Nutzer / Monat`)
	return /** @type {LocalizedString} */ (`€${i?.price} / user / month`)
});